import { DangerZoneSection } from "./danger-zone-section";
import { PasskeySection } from "./passkey-section";
import { ProfileSection } from "./profile-section";

export function AccountSettings() {
  return (
    <div className="flex flex-col gap-8 max-w-2xl">
      <div>
        <p className="text-sm text-muted-foreground">
          Manage your account security and preferences.
        </p>
      </div>

      <ProfileSection />

      <hr className="border-border" />

      <PasskeySection />

      <hr className="border-border" />

      <DangerZoneSection />
    </div>
  );
}
